import { useEffect } from 'react';

export default function PerformanceOptimizer() {
  useEffect(() => {
    // Optimize scroll performance - use RAF to batch reads/writes and avoid forced reflow
    let rafId: number | null = null;
    
    const handleScroll = () => {
      if (rafId) return; // Debounce
      rafId = requestAnimationFrame(() => {
        if (window.scrollY > 100) {
          document.body.classList.add('scrolled');
        } else {
          document.body.classList.remove('scrolled');
        }
        rafId = null;
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return null;
}
